import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import { dyn, scheduleForCleanup } from "trader.ts/ui";
import { textbox } from "trader.ts/ui.common";
import { Parsing } from "trader.ts/ui.forms";
import * as FA from "./../../styles/fontawesome.css.classes";
import * as style from "./../../styles/style.css.classes";
import { debounce } from "./debounce";
import { sleep } from "./sleep";
import { checkAllCasesHandled } from "trader.ts/utils";

export function textboxWithAutosave(opts: {
  source: Source<string>;
  label: string;
  save: (s: string) => Promise<unknown>;
  type?: string;
}) {
  const source = opts.source;
  const savedS: Source<Parsing<null>> = new Source({ tag: "initial" });
  let savei = 0;
  const debouncedDoSave = debounce(function doSave(s: string) {
    savei++;
    const myi = savei;
    opts
      .save(s)
      .then(() => savedS.set({ tag: "parsed", parsed: null }))
      .catch(() => savedS.set({ tag: "err" }))
      .finally(async () => {
        await sleep(1500);
        // To avoid race conditions
        if (myi === savei) {
          savedS.set({ tag: "initial" });
        }
      });
  }, 1000);
  scheduleForCleanup(
    source.observe((s) => {
      savedS.set({ tag: "loading" });
      debouncedDoSave(s);
    }),
  );

  return (
    <div style="position: relative">
      {textbox({
        source,
        label: opts.label,
        type: opts.type,
      })}
      {renderSavingIndicator(savedS, {
        style: "position: absolute; top: 2.2rem; right: 1rem;",
      })}
    </div>
  );
}

export function renderSavingIndicator(
  savedS: Source<Parsing<null>>,
  opts: {
    style: string;
  },
): HTMLElement[] {
  const iconStyle = "position: static; margin: 0px;";
  return dyn(savedS, (saved) => {
    if (saved.tag === "initial") {
      return <span></span>;
    } else if (saved.tag === "err") {
      return (
        <span style={opts.style}>
          <i
            className={FA.icon_exclamation_circle_solid}
            style={iconStyle + "color: red"}
          ></i>
        </span>
      );
    } else if (saved.tag === "loading") {
      return (
        <span style={opts.style}>
          <span className={style.loading}></span>
        </span>
      );
    } else if (saved.tag === "parsed") {
      return (
        <span style={opts.style}>
          <i
            className={FA.icon_save_solid}
            style={iconStyle + "color: green"}
          ></i>
        </span>
      );
    } else {
      return checkAllCasesHandled(saved);
    }
  });
}
